import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number): string {
  return new Intl.NumberFormat('ar-DZ').format(price);
}

export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

/**
 * Dynamic route params for non-ASCII slugs (Arabic product/device slugs)
 * can arrive still percent-encoded in page `params` (observed: `%D8%AC...`
 * instead of `جراب...`), which silently breaks exact-match DB lookups and
 * 404s the page. Decode defensively; fall back to the raw segment when it
 * is not valid percent-encoding (e.g. a literal `%`).
 */
export function decodeRouteParam(segment: string): string {
  if (!segment.includes('%')) {
    return segment;
  }
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
